import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';
import Pagination from 'components/molecules/pagination';
import { useOnboardingStatusQueryFilter } from 'infrastructure/hooks/rpm/onboarding-status-report';
import { CORE_PATIENTS_PER_PAGE } from 'infrastructure/hooks/patient/use-get-core-patients';

const Sorting = ({ count, data }) => {
  const { filter, updateFilter } = useOnboardingStatusQueryFilter();

  return (
    <Row>
      <Col>
        <Pagination
          title=""
          page={filter.page}
          pageTotal={data.length}
          itemsPerPage={CORE_PATIENTS_PER_PAGE}
          total={count}
          handleFirstClick={() => updateFilter({ page: 1 })}
          handleLastClick={() =>
            updateFilter({ page: Math.ceil(count / CORE_PATIENTS_PER_PAGE) })
          }
          handlePrevClick={() => updateFilter({ page: filter.page - 1 })}
          handleNextClick={() => updateFilter({ page: filter.page + 1 })}
          loading={false}
        />
      </Col>
    </Row>
  );
};
Sorting.propTypes = {
  data: PropTypes.array,
  count: PropTypes.number,
};

export default Sorting;
